import { useGetStatsQuery } from '@platform/state/api';
import type { IRecordListModel } from '@platform/core/types';
import { useListParams } from '../useListParams';
import type { ICreateKinds } from './ICreateKinds';
import { kindFieldOf } from './kindFieldOf';

/**
 * Види нового запису для панелі списку (прототип v4 baNewMenu/baNewSingle): у типу з полем виду — варіанти поля й вид записів списку, коли
 * він один (статистика за полем виду з тим самим відбором, що й список); інакше undefined (звичайна кнопка «+ Створити …»).
 */
export function useCreateKinds(model: IRecordListModel): ICreateKinds | undefined {
  const field = kindFieldOf(model.rt);
  const params = useListParams(model);
  const { data } = useGetStatsQuery({ ws: model.ws, rt: model.rt.key, by: field?.key ?? '', params }, { skip: !field });
  if (!field) return undefined;
  const present = (data?.buckets ?? []).filter((b) => b.count > 0 && b.value);
  const single = present.length === 1 ? present[0]?.value : undefined;
  return { field: field.key, options: field.options ?? [], ...(single ? { single } : {}) };
}
